import { useTranslation } from "react-i18next"
import { useDownload } from "../../../../../../../../hooks/download/useDownload"
import { loogbookServiceFetch } from "../../../../../../../../utils/constants/callService"
import { returnQueryWithPagination } from "../../../../../../../../utils/methods/returnQuery"
import { TableActions } from "../../tableActions"
import { useLogbookContext } from "../../../../context"
import { Hashs } from "../../../activityRegister/utils"
import { formatUserMapFilter, QueryActivity } from "../../../../utils"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"
import { LinearProgressDownload } from "../linearProgressDownload"
import { UserSection } from "../../../../utils/enums/userSection"

export const OneUserActivityAction = () => {
    const { filter: { filterOneUser: { filter }, filterListUser, filterUser }, service: { getDetailInform }, state: { uuid, loading }, setVisibleUsersDataByUser } = useLogbookContext()
    const { t } = useTranslation()
    const location = useLocation()
    const queary = new URLSearchParams(location.search)
    const usersIds: string = queary.get(QueryActivity.IDS) ?? ''
    const query = `&user_ids=${usersIds}${returnQueryWithPagination({ filter: filter.filterString }, formatUserMapFilter)}`;
    const downloadCustome = () => {
        getDetailInform({ query: query, uuidTab: UserSection.ONE_USER_ACTIVITY })
    }
    const cleanFilterAll = () => {
        filter.cleanFilter()
        filterListUser.filter.cleanFilter()
        filterUser.filter.cleanFilter()
        setVisibleUsersDataByUser({})
    }
    const {
        download,
        openSnackbar,
        downloadCSV,
        downloadPDF,
        downloadWORD,
        closeOpenSnakbar
    } = useDownload({
        query: query,
        docName: t('loogbook.activity'),
        downloadFuntion: loogbookServiceFetch.downloadLogbook,
    })

    useEffect(() => {
        if (uuid.ONE_USER_ACTIVITY) {
            const interval = setInterval(() => {
                getDetailInform({ query, uuidTab: UserSection.ONE_USER_ACTIVITY });
            }, 30000);
            return () => clearInterval(interval);
        } 
    }, [uuid.ONE_USER_ACTIVITY])

    return (<>
        <LinearProgressDownload show={loading.ONE_USER_ACTIVITY} text={t('loogbook.generateDetailInform')} />
        <TableActions
            download={{
                csv: downloadCSV,
                pdf: downloadPDF,
                word: downloadWORD,
                disableCSV: download?.excel,
                disablePDF: download?.pdf,
                disableWORD: download?.word,
            }}
            count={filter.counter}
            cleanActivityButton={{ onClick: cleanFilterAll }}
            downloadCustome={downloadCustome}
            downloadDisabled={{ 'pdf-detail': loading.ONE_USER_ACTIVITY, excel: false, pdf: false, word: false }}
            closeOpenSnakbar={closeOpenSnakbar}
            openSnackbar={openSnackbar}
            addActivityButton={{ onClick: () => { window.location.hash = Hashs.CREATE } }}
        />
    </>)
}